import React from "react";
import styled from "styled-components";

import colorBar from "images/v3/icons/color_bar.svg";

const ColorBar = styled.img`
	width: 74px;
	position: absolute;
	top: 0;
	left: calc(50% - (74px / 2));
`;

const Wrapper = styled.div`
	position: relative;
	height: fit-content;
	outline: #d7761d;
	background-color: #d5dcdd;
	padding: 30px;
	color: #01788a;
	text-align: center;

	&::after {
		content: " ";
		pointer-events: none;
		position: absolute;
		box-sizing: border-box;
		top: -10px;
		left: -10px;
		width: 100%;
		height: 100%;
		border: 2px solid #d7761d;
	}
`;

const Heading = styled.h5`
	margin: 0;
	font-size: 1.5em;
	text-transform: uppercase;
`;

const Contact = styled.address`
	padding: 10px 0;
	font-family: "Open Sans";
	font-style: normal;
	font-size: 0.9em;
	color: #012126;
`;

const Separator = styled.hr`
	border-top: 1px solid #b6b6b6;
`;

const Caption = styled.p`
	margin-bottom: 5px;
	font-size: 1.05em;
	font-weight: bold;
	color: #599ba4;
	text-transform: uppercase;
`;

const Stat = styled.p`
	margin: 10px;
	margin-top: 0;
	font-size: 2em;
	font-weight: bold;
	color: #01788a;
`;

const Website = styled.a`
	color: #01788a;
	text-decoration: underline;
`;

const TrackCard = (props) => {
	const {
		track,
		lap_length_miles,
		number_of_turns,
		elevation_change_feet,
		phone,
		hours,
		track_website_url,
	} = props;
	const { name, address, city, state, zip } = track;

	return (
		<Wrapper>
			<ColorBar src={colorBar} />
			<h5 className="TGh5">{name}</h5>
			<address className="TGaddress">
				{address}
				<br />
				{city}, {state} {zip}
				<br />
				<Website href={track_website_url}>Website</Website>
			</address>
			<Separator />
			<h5 className="TGh5">By the Numbers</h5>
			<Separator />
			<p className="TGp4">Lap Length</p>
			<p className="TGp5">{lap_length_miles} Miles</p>
			<Separator />
			<p className="TGp4">Turns</p>
			<p className="TGp5">{number_of_turns}</p>
			<Separator />
			<p className="TGp4">Feet of Elevation Changes</p>
			<p className="TGp5">{elevation_change_feet}</p>
		</Wrapper>
	);
};

export default TrackCard;
